import React, { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import ReportStatusBadge from '../components/ReportStatusBadge'
import { useListClientStatusReports } from '../../../../../api/groups'
import OpalPresentationTable from '../../../../organisms/DenaliAnalysis/tables/presentation'
import { useFormattingContext } from '../../../../organisms/FormattingProvider/FormattingContext'

function StatusReportHistoryTab () {
  const { statusTemplateId, levelId } = useParams()
  const { formatter } = useFormattingContext()

  const { data, isLoading, isFetching } = useListClientStatusReports({
    filters: {
      statusTemplateId,
      levelId
    }
  })

  const previousReports = useMemo(() => {
    if (!data?.statusReports) return []
    return data?.statusReports?.filter(sr => !sr.isActiveStatusReport) || []
  }, [data])

  const previousReportsColumns = [
    {
      accessorKey: 'asOfDate',
      header: 'As of Date',
      cell: ({ getValue }) => formatter(getValue(), '@MM/DD/YY')
    },
    {
      accessorKey: 'status',
      header: 'Status',
      cell: ({ getValue }) => <ReportStatusBadge codeName={getValue()} />
    },
    {
      accessorKey: 'statusTemplateName',
      header: 'Template'
    },
    {
      accessorKey: 'finalizedAt',
      header: 'Finalized',
      cell: ({ getValue }) => getValue() ? formatter(getValue(), '@MM/DD/YY') : '-'
    }
  ]

  return (
    <OpalPresentationTable
      isLoading={isLoading || isFetching}
      data={previousReports}
      columns={previousReportsColumns}
      className='zebra-rows'
    />
  )
}

export default StatusReportHistoryTab
